// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__4CtOB","calendarButtons":"ClockData_calendarButtons__1tuL8"};